export default __webpack_public_path__ + "static/media/persotype_files_icon.efd64974.svg";